import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const useDeviceCheck = () => {
  const theme = useTheme();
  return {
    isMobile: useMediaQuery(theme.breakpoints.down("sm")),
    isTablet: useMediaQuery(theme.breakpoints.down("md")),
    isSmallDesktop: useMediaQuery(theme.breakpoints.down("lg")),
  };
};

export default useDeviceCheck;
